import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const support = {
    namespaced: true,
    state: {
      finalIssueList: [],
      ticketContent: {},
    },
    getters: {
      getFinalIssueList (state) {
        return state.finalIssueList;
      },
      getTicketContent (state) {
          return state.ticketContent;
      },
    },
    mutations: {
      setFinalIssueList (state, data) {
        state.finalIssueList = data;
      },
      setTicketContent (state, data) {
        state.ticketContent = data;
      },
      clearOffTicketContent (state) {
        state.ticketContent = {};
      },
    },
    actions: {
      async createIssueTicket ({ dispatch }, payload) {
        const url = '/support/tickets';
        try {
          await axios.post(url, payload);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in creating the ticket.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
        }
      },
      async fetchSupportTickets ({ dispatch, commit, state }, { params }) {
        const url = '/support/tickets';
        try {
            const response = await axios.get(url, { params: params });
                commit('setFinalIssueList', response.data);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in getting all open tickets.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
        }
      },
      async deleteIssueTicket ({ dispatch }, ticketId) {
        const url = `/support/tickets/${ticketId}`;
        try {
            await axios.delete(url);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in deleting this ticket.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
        }
      },
      async fetchTicketContent ({ dispatch, commit }, payload) {
        const url = `support/tickets/${payload.id}`;
        try {
            const details = await axios.get(url);
            commit('setTicketContent', details.data);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in getting the ticket details.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
        }
      },
      clearTicketContent ({ commit }) {
        commit('clearOffTicketContent');
      },
      async updateIssueTicket ({ dispatch }, payload) {
        const url = `/support/tickets/${payload.id}`;
        try {
          await axios.put(url, payload);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in updating the ticket.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
        }
      },
    },
};
